import script from "./Venues.vue?vue&type=script&setup=true&lang=js"
export * from "./Venues.vue?vue&type=script&setup=true&lang=js"

import "./Venues.vue?vue&type=style&index=0&id=54c350fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54c350fa"]])

export default __exports__